export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/store-login-picw-053e91081825ff3c36b5e313e1219f03.webp";